import { createSelector } from 'reselect';

const selectUserState = (state) => state.user;

const selectUsername = createSelector(
  [selectUserState],
  (user) => user.username,
);

const selectIsAuthenticated = createSelector(
  [selectUserState],
  (user) => !!user.isAuthenticated,
);

const selectToken = createSelector([selectUserState], (user) => user.token);

export { selectIsAuthenticated, selectToken, selectUsername };
